import { useQuery } from "@tanstack/react-query";
import { queryClient } from "shared/api/queryClient";
import { getSettingsListByBrand } from "../api/getSettingsListByBrand";
import { BrandSetting } from "../types";

export const useSettingsListByBrandQuery = (brandId: string) => {
  return useQuery({
    queryKey: ["brand-settings", brandId],
    queryFn: () => getSettingsListByBrand(brandId),
  });
};

export const invalidateSettingsListByBrandsQuery = (brandId: string) => {
  return queryClient.invalidateQueries({
    queryKey: ["brand-settings", brandId],
  });
};

export const getSettingsListByBrandQueryData = (brandId: string) => {
  return queryClient.getQueryData<BrandSetting[]>(["brand-settings", brandId]);
};

export const setSettingsListByBrandQueryData = (brandId: string, data: any) => {
  return queryClient.setQueryData(["brand-settings", brandId], data);
};
